import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { SignupPasswordPage } from './signup-password';

@NgModule({
  declarations: [
    SignupPasswordPage
  ],
  imports: [
    IonicPageModule.forChild(SignupPasswordPage)
  ],
  exports: [
    SignupPasswordPage
  ],
  entryComponents: [
    SignupPasswordPage
  ]
})
export class SignupPasswordModule {}



// WEBPACK FOOTER //
// ./src/pages/signup-password/signup-password.module.ts